<template>
  <div class="content-page mobile-app">
    <div class="main-page">
      <div class="title-page">选择申请类型</div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <!-- 主要内容区域 -->
          <div class="choose-buttons">
            <div class="choose-btn personal-btn" @click="selectCategory('1')">
              个人
            </div>
            <div
              class="choose-btn organization-btn"
              @click="selectCategory('2')"
            >
              法人/组织
            </div>
          </div>
          <div class="btnLists">
            <div class="border-btn" style="marginleft: 20px" @click="goBack">
              返回上一页
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { uuid } from "@/utils";
import Api from "@api/api";

const moduleCodeSwitch = () => {
  switch (localStorage.getItem("oprate")) {
    case "apply":
      return "1";
      break;
    case "search":
      return "2";
      break;
    case "revokeApply":
      return "3";
      break;
  }
};

export default {
  data() {
    return {
      caseOrderNo: uuid(), // 生成的案件流水号
      identificationApplicant: uuid(), // 申请人id 都uuid生成
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  methods: {
    selectCategory(applicantCategory) {
      // 从 localStorage 的 applicantInfo 中获取数据
      const applicantInfo = localStorage.getItem("applicantInfo")
        ? JSON.parse(localStorage.getItem("applicantInfo"))
        : null;

      // 从 store 中获取用户信息，如果没有则从 applicantInfo 中获取
      const phone = applicantInfo
        ? applicantInfo.phone
        : this.$route.query.phone || "";
      const loginName =
        this.user.loginName ||
        (applicantInfo ? applicantInfo.loginName : "") ||
        this.$route.query.loginName ||
        "";
      const identificationCard =
        this.user.identificationCard ||
        (applicantInfo ? applicantInfo.identificationCard : "") ||
        this.$route.query.identificationCard ||
        "";

      // 人口库校验，调用 saveLoginInfo 接口获取 searchType
      const applicantInfoListCal = [];
      applicantInfoListCal.push({
        name: loginName,
        id: identificationCard,
      });
      const searchType = this.$route.query.searchType || "";

      localStorage.setItem("applicantCategory", applicantCategory); // 存储申请人类型
      localStorage.setItem('applicantInfo', JSON.stringify({
        ...JSON.parse(localStorage.getItem('applicantInfo')),
        applicantCategory: applicantCategory
      }));
      // 更新 applicantInfo
      const updatedApplicantInfo = {
        ...applicantInfo,
        loginName: loginName,
        identificationCard: identificationCard,
        phone: phone,
        applicantCategory: applicantCategory,
        moduleCode: moduleCodeSwitch(),
        id: "",
        verificationCode: "",
        fileGh: null,
        fileListJpg: [],
        fileListJpg2: [],
        fileRx: null,
      };
      localStorage.setItem(
        "applicantInfo",
        JSON.stringify(updatedApplicantInfo)
      );
      if (localStorage.getItem("oprate") == "apply") {
        this.$router.push({
          name: "MNewCase",
          query: {
            name: "Register",
            caseOrderNo: this.caseOrderNo,
            identificationApplicant: this.identificationApplicant,
          },
        });
      } else {
        this.$router.push({
          name: "Mcaselist",
          query: {
            name: localStorage.getItem("oprate"),
            phone: phone,
            searchType: searchType,
            loginName: loginName,
            applicantCategory: applicantCategory,
            identificationCard: identificationCard,
          },
        });
      }
    },
    goBack() {
      if (localStorage.getItem("oprate") == "apply") {
        this.$router.push("/m-howApply");
      } else {
        this.$router.push("/m-codeSearch");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.backgroundBox {
  height: 100%;
}
@media screen and (max-width: 1000px) {
  .main-contentBox {
    padding: 15px 20px 15px !important;
    height: 100%;
  }
}
.main-contentBox {
  width: 100%;
  height: 600px;
  padding: 60px 135px 80px;
  @media screen and (max-width: 750px) {
    padding: 16px;
  }
}
.choose-buttons {
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  .choose-btn {
    height: 70px;
    width: 300px;
    border-radius: 10px;
    border: 1px solid #fff;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    background: linear-gradient(90deg, #e4c995 0%, #b9916a 100%);
    cursor: pointer;
    transition: opacity 0.3s;
    @media screen and (max-width: 750px) {
      width: 100%;
      max-width: 300px;
      height: 48px;
      font-size: 14px;
    }
    &:active {
      opacity: 0.8;
    }
  }
}

.btnLists {
  margin: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 750px) {
    margin: 16px 0;
  }
  .border-btn {
    padding: 0 20px;
    height: 48px;
    font-size: 16px;
    line-height: 48px;
    color: #000000;
    border: 1px solid #cbb486;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    background: transparent;
    @media screen and (max-width: 750px) {
      height: 48px;
      font-size: 14px;
      line-height: 48px;
    }
    &:active {
      opacity: 0.8;
    }
  }
}
</style>
